import './style.scss';
import { ModalBase, ModalStyle } from 'views/components/atoms/modal';
import { ChangePasswordBody } from '.';
import { useState } from 'react';
import { Guidances } from 'views/components/atoms/guidances';
import { ChangePasswordProps } from './hooks';

export const ChangePasswordModal = (props: ChangePasswordProps) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <ModalBase
      modalStyle={ModalStyle.confirmModal}
      isOpen={isOpen}
      children={
        <div className="changePasswordModal">
          <Guidances
            label={
              <>
                <div>初期パスワードでのログイン時は</div>
                <div>パスワードの変更をしてください</div>
              </>
            }
            isRowGapMin={true}
          />
          <ChangePasswordBody
            isModal={true}
            onCompleted={() => {
              props.onCompleted?.();
              setIsOpen(false);
            }}
          />
        </div>
      }
      shouldCloseOnOverlayClick={false}
    />
  );
};
